import { withInstall } from '@tw-element/utils'
import Progress from './src/progress.vue'

export const TwProgress = withInstall(Progress)
export default TwProgress

export * from './src/progress'
